import {
  LOGIN3,
  LOGIN3_SUCCESS,
  LOGIN3_FAILED,
  RECONNECT3,
  RECONNECT3_SUCCESS,
  // SET_THEME3,
  SET_USER_PERSISTENT_PROFILE3,
  UPDATE_USER_ATTRIBUTES3,
  REFRESH_TOKEN,
  CANCEL_LOGIN,
  COLLECT3,
  LOGIN3_SESSION,
  LOGIN3_METADATA
} from "../constants";

/**
 * Request login
 */
export function login3({ strategy, props,source }) {
  return {
    type: LOGIN3,
    props,
    strategy,
    source
  };
}

/**
 * Collect login
 */
 export function collect3({ strategy,props,source,session }) {
  return {
    type: COLLECT3,
    strategy,
    session,
    source,
    props
  };
}

export const login3Success = ({
  userName,
  userID,
  roles,
  url,
  orgId,
  orgName,
  orgColor,
  configuration,
  permissions,
  user,
  theme,
  themes,
  defaultBuilderRoles,
  userPersistentProfile }
) => {

  return {
    type: LOGIN3_SUCCESS,
    userName: userName,
    userID: userID,
    roles: roles,
    url: url,
    orgId: orgId,
    orgName: orgName,
    orgColor: orgColor,
    configuration: configuration,
    permissions: permissions,
    isAuthenticated: true,
    user,
    theme,
    themes,
    defaultBuilderRoles,
    userPersistentProfile,
  };
};

export function login3Failed({ errorMsg }) {
  return {
    type: LOGIN3_FAILED,
    errorMsg
  };
}

/**
* reconnect. happens when a user hits f5 during a logged in session
*/
export function reconnect3({ token }) {
  return {
    type: RECONNECT3,
    token
  };
}


/**
 * Issued when a user successfully reconnected to Selfpoint. I.e. when we got the userData values from the servver
 */
//eslint-disable-next-line
export const reconnect3Success = ({}) => {

  return {
    type: RECONNECT3_SUCCESS,
  };
};

// /**
// * set the current theme
// */
// export function setTheme3({name}) {
//   return {
//     type: SET_THEME3,
//     name
//   };
// }

/**
 * Set user-pp with value. 
 * 
 * The reset flag determines if we should set a new empty object or merge with old value
 * 
 * @param {object} payload - The payload to update the UPP with
 * @param {boolean} reset - If set to true, the current userPP will be reset with payload, if set to fasle it will be merged with current userPP
 */
export function setUserPersistentProfile(payload, reset = false) {
  return {
    type: SET_USER_PERSISTENT_PROFILE3,
    payload,
    reset
  };
}


export function updateUserAttributes(attributes) {
  return {
    type: UPDATE_USER_ATTRIBUTES3,
    attributes
  }
  
}

export function refreshToken3({}) {
  return {
    type: REFRESH_TOKEN
  };
}

export function cancelLogin({strategy, session}) {
  return {
    type: CANCEL_LOGIN,
    session,
    strategy
  };
}

export function loginSession(sessionData) {
  return {
    type: LOGIN3_SESSION,
    sessionData,
  };
}

export function loginMetadata(metadata) {
  return {
    type: LOGIN3_METADATA,
    metadata,
  };
}

